import { render, staticRenderFns } from "./FluxoCaixaCategoriasModule.vue?vue&type=template&id=53cb933d"
import script from "./FluxoCaixaCategoriasModule.vue?vue&type=script&lang=js"
export * from "./FluxoCaixaCategoriasModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports